import { render, staticRenderFns } from "./InsightIndex.vue?vue&type=template&id=25fbc20c&"
import script from "./InsightIndex.vue?vue&type=script&lang=js&"
export * from "./InsightIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports